import React from 'react'
import { showBlogInfo } from '../../../helper'


const data = [
    { 
        title : 'What Kind of Personal Information We Collect',
        subs : [
            {
                sub1 : 'While providing Our services We may collect the “Personal Information” which is defined as any information that identifies or can be used to identify, contact, or locate the person to whom such information pertains. Namely, we may collect :',
                sub2 : [
                    {
                        text : 'Identity information: name, facial image, social security number, ID number, documents proving your identity and any other information they may contain;'
                    },
                    {
                        text : 'Residential information: IP address, residence address, documents proving your residency and any other information they may contain;'
                    },
                    {
                        text : 'Contact information: email address, mailing address, phone number;'
                    },
                    {
                        text : 'Security information: alias;'
                    },
                    {
                        text : 'Cookies: to know more about cookies please acquaint yourself with Our Cookie Policy;'
                    },
                    {
                        text : 'Your mobile devices You use with the Technology Platform may provide some information that may potentially identify You, such as the type (including identifiers) of the device, platform type, mobile phone number, your internet service, operating system, geolocation information, browser You use, browser language, or the pages You visit, etc.;'
                    },
                    {
                        text : 'The Technology Platform may collect some of Your behavior information, such as Your visiting the Technology Platform, clicking on ads or other similar information. Such information may be received with additional related data (or metadata), such as the time, date, and location related to such information;'
                    },
                    {
                        text : 'Sometimes you decide to share with us some other Personal Information and we may collect it as well.'
                    },
                ]
            },
            {
                sub1 : 'We do not collect any information that may identify You without your permission. However, We use Google Analytics on Our Technology Platform. If You want to know more about Google Analytics and its “do not track” policy, please visit https://www.google.com/analytics/terms/us.html',
                sub2 : []
            },
        ]
    },
    {
        title : 'How We Use Your Personal Information',
        subs : [
            {
                sub1 : 'We, our authorized partners and our representatives store and use Your Personal Information only for providing and improving the Technology Platform. In particular, we use Users’ Personal Information for the following purposes :',
                sub2 : [
                    {
                        text : 'To provide you the Services: We may use information to execute your transaction requests and trade orders;',
                    },
                    {
                        text : 'To comply with our legal obligations: In many jurisdictions we are obliged to collect certain information about our Users to be authorized to act (Know Your Client and Anti-Money Laundering regulations);',
                    },
                    {
                        text : 'To protect your assets: We may use information to identify you and the assets belonging to you in order to secure access to your accounts and to prevent the fraud;',
                    },
                    {
                        text : 'To improve customer service: information provided by Users helps Us respond to customer service requests and support needs more efficiently;',
                    },
                    {
                        text : 'To personalize User experience: We may use information in a general manner to understand how Our Users as a group use the services and resources provided on Our Technology Platform;',
                    },
                    {
                        text : 'To improve Our Technology Platform: We may use the feedback provided by Users to improve Our products and services;',
                    },
                    {
                        text : 'To maintain Our Technology Platform: We may use the information Users provide about themselves when receiving transaction request only to provide service to that request;',
                    },
                    {
                        text : 'To send periodic emails: We may use the email address to send information and updates pertaining to Your use of the transaction request;',
                    },
                    {
                        text : 'To resolve disputes and enforce our agreements to the extent necessary and sufficient for protecting your interests or interests of other Users.',
                    },
                ]
            },
            {
                sub1 : 'We strictly follow industry best practices in the industry and adhere to the rules set forth in GDPR, OPPA, CAN-SPAM and COPPA.',
                sub2 : [],
            },
        ]
    },
    {
        title : 'How We Can Share the Information',
        subs : [
            {
                sub1 : 'In certain situations, We may be required to disclose personal data in response to lawful requests by competent authorities, including to meet national security, public interests or law enforcement requirements. Our policies regarding exchange of information with competent authorities is reflected in Our Transparency Policy.',
                sub2 : [],
            },
            {
                sub1 : 'We may disclose your Personal Information where required by law (e.g., to comply with a subpoena, warrant, court order, or legal process served on tobtc platform), and when we believe that disclosure is necessary to protect our rights, avoid litigation, protect your safety or the safety of others, investigate fraud, and/or respond to a government request.',
                sub2 : [],
            },
        ]
    },
    {
        title : 'For How Long We Retain Your Personal Information',
        subs : [
            {
                sub1 : 'We will retain your information for as long as your account is active, your information is needed to provide you services, or as required to fulfil our legal obligations.',
                sub2 : []
            },
        ]
    },
    {
        title : 'How We Protect Your Information',
        subs : [
            {
                sub1 : 'We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of Your personal information, username, password, transaction information and data stored on Our Technology Platform.',
                sub2 : []
            },
            {
                sub1 : 'Sensitive and private data exchange between the Technology Platform and its Users happens over an SSL-secured communication channel and is encrypted and protected with digital signatures. Our Technology Platform is functioning in compliance with PCI vulnerability standards in order to create an environment as secure as possible for Users.',
                sub2 : []
            },
            {
                sub1 : 'Unfortunately, there is no such thing as completely secure data transmission or storage, so We cannot guarantee that Our security will not be breached (by technical measures or through violation of Our policies and procedures).',
                sub2 : []
            },
            {
                sub1 : 'Without prejudice to Our efforts on protection of Your information nothing herein constitute a warranty of security of the Technology Platform, and You agree to transmit information at Your own risk. Please note, that the Technology Platform does not guarantee that Your information may not be accessed, disclosed, altered, or destroyed by breach of any of Our physical, technical, or managerial safeguards.',
                sub2 : []
            },
        ]
    },
    {
        title : 'What Are Your Rights to Your Data',
        subs : [
            {
                sub1 : 'All Your Personal Information we collect will always belong to you. However, we are a collector and a processor of Your Personal Information. That implies on us obligations to respect your rights to Personal Information and facilitate the exercise of your rights thereto. In order to use any of Your rights at any time please contact us and we will facilitate the exercise of your rights free of charge. We will inform You on the actions taken by Us under Your request as soon as practically possible, but in any case not later than in 30 (thirty) calendar days.',
                sub2 : []
            },
            {
                sub1 : 'In accordance with effective regulations You have a significant number of rights related to your Personal Information, such as e.g. :',
                sub2 : [
                    {
                        text : 'Right to access. You may obtain from Us the confirmation as to whether or not personal data concerning You is being processed and get an access to such personal data;',
                    },
                    {
                        text : 'Right to rectify Your inaccurate Personal Information and to have incomplete personal data completed, including by means of providing a supplementary statement',
                    },
                    {
                        text : 'Right to erase your Personal Information. Please note that a request to erase your Personal Information will also terminate your account on the Site. We will automatically and without undue delay erase your Personal Information when it is no longer necessary in relation to the purposes for which it was collected or otherwise processed;',
                    },
                    {
                        text : 'Right to restrict processing of your Personal Information;',
                    },
                    {
                        text : 'Right to data portability. You may obtain from Us the personal data concerning You and which You have provided to us and transmit it to another Personal Information Controller;',
                    },
                    {
                        text : 'Right to object to processing of Your Personal Information,',
                    },
                    {
                        text : 'Right to withdraw your consent to the usage of your Personal Information at any time',
                    },
                    {
                        text : 'Right to lodge a complaint. We take privacy concerns seriously. If you believe that we have not complied with this Privacy Policy with respect to your Personal Information, you may contact our respective Data Protection Office. We will investigate your complaint promptly and will reply you within 30 (thirty) calendar days. If you do not receive acknowledgment of your complaint or your complaint is not satisfactorily addressed, you have the right to lodge a complaint with the respective supervisory authority:',
                    },
                ]
            },
        ]
    },
    {
        title : 'Children',
        subs : [
            {
                sub1 : 'We do not intend to solicit or collect Personal Information from anyone under the age of 18 or under the legal age of your country, if it is higher. If you are under 18 or are not of a legal age of your country, do not enter any personal information on our Technology Platform.',
                sub2 : []
            },
        ]
    },
    {
        title : 'Changes to the Privacy Policy',
        subs : [
            {
                sub1 : 'The Technology Platform has the discretion to update this Policy at any time. User should check this Privacy Policy periodically. Your continued use of the service after We post any modifications to the Privacy Policy on this page will constitute Your acknowledgment of the modifications and Your consent to abide and be bound by the modified Privacy Policy.',
                sub2 : []
            },
            {
                sub1 : 'If We make any material changes to this Privacy Policy, We will notify You either through the email address You have provided Us, or by placing a prominent notice on the Technology Platform. You acknowledge and agree that it is Your responsibility to review this privacy policy periodically and become aware of modifications.',
                sub2 : []
            },
        ]
    },
    {
        title : 'Contacting Us',
        subs : [
            {
                sub1 : 'If You have any questions about this Privacy Policy, wish to exercise any of Your rights to your Personal Information or file a complaint, please contact Us at:E-mail: legal@tobtc.io',
                sub2 : []
            },
        ]
    },
]

  
function PrivacyPolicy() {
  return (
    <div className="nk-wrap">
        <header className="nk-header" id="privacy-policy">
            <div className="header-banner section">
                <div className="nk-banner">
                    <div className="banner banner-page">
                        <div className="banner-wrap">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-xl-6 col-lg-9">
                                        <div className="banner-caption cpn tc-light text-center">
                                            <div className="cpn-head">
                                                <h2 className="title ttu">Privacy Policy</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-ovm shape-a-sm"></div>
            </div>
        </header>
        <main className="nk-pages">
            <section className="section bg-white">
                <div className="container">
                    <div className="">
                        <div className="row">
                            <div className="col-12">
                                <div className="">
                                    <div className="row justify-content-center">
                                        <div className="col-xl-8 col-lg-10">
                                            <div className='blog-content'>
                                                    <p>Legal name : TOBTC TRADING YÖNETIM DANISMANLIGI TICARET LiMiTED VERGi KiMLiK SIRKETi<br />
                                                    Reg number : 361812-5<br />
                                                    Country : Turkey
                                                    </p>
                                                {showBlogInfo(data)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
  )
}

export default PrivacyPolicy